module.exports = __webpack_public_path__ + "a47b0390f8e001d0a7398db5796dd00d.svg";


//////////////////
// WEBPACK FOOTER
// ./~/ui-text-editor/src/fonts/3dprint.svg?hntrwn
// module id = 402
// module chunks = 0